import React from 'react';
import { Button, Tab, Responsive } from 'semantic-ui-react';
import MobilityList from './MobilityList';
import MobilityGrades from './MobilityGrades';
import MobilityCourses from './MobilityCourses';
import StudentMobilityIntership from './StudentMobilityInternship';


export default class MobilityDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            student: JSON.parse(localStorage.getItem('student')),
            mob: props.mob || JSON.parse(localStorage.getItem('mob')),
            step: false,
        };
        this.handleBack = this.handleBack.bind(this);
    }

    handleBack() {
        if (this.props.onBack) {
            this.props.onBack();
        } else {
            this.setState({ step: true });
        }
    }

    render() {
        const activeRole = localStorage.getItem('activeRole') || '';
        const isStudentService = activeRole.substr(0, 10) === 'Studentska';
        const readOnly = this.props.limitation || !isStudentService;
        const panes = [
            {
                menuItem: 'Ocjene',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <MobilityGrades limitation={readOnly} />
                </Tab.Pane>)
            },
            {
                menuItem: 'Praksa',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <StudentMobilityIntership limitation={readOnly} />
                </Tab.Pane>)
            },
            {
                menuItem: 'Predmeti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <MobilityCourses limitation={readOnly} />
                </Tab.Pane>)
            },
        ];

        if (this.state.step === true) {
            return (<MobilityList limitation={readOnly} />);
        }

        return (<div>
            <Tab
                panes={panes}
                menu={{
                    secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                }}
                grid={{ paneWidth: 14, tabWidth: 2 }}
            />
            {!this.props.hideBackButton && <React.Fragment>
                <br />
                <Button
                    color="blue"
                    floated="left"
                    basic="true"
                    onClick={this.handleBack}
                >Nazad
                </Button>
                <br />
                <br />
            </React.Fragment>}
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/MobilityDetails.js